<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        @search="search"
      />
    </el-card>
    <el-card>
      <div class="flex justify-end mb-20">
        <el-button type="success" size="mini" @click="batchEditRebate">批量设置返点</el-button>
        <el-button type="primary" size="mini" @click="pullMedias">同步媒体账号</el-button>
        <el-button type="warning" size="mini" @click="refreshAuthCache">刷新授权缓存</el-button>
        <el-button type="danger" size="mini" @click="batchUpdateAccountStatus">批量修改账号状态</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getMediasList"
        :is-row-click="false"
        :check="true"
        @select-tr="onSelectionChange"
      />
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      width="500px"
    >
      <app-form
        v-if="dialog_config.is_show"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      >
        <template #custom="{ form_key, form_item }">
          <div v-if="form_key === 'ids'">
            <span style="color: #F56C6C;">{{ form_item.value.length }}</span>
          </div>
        </template>
      </app-form>
    </el-dialog>
  </div>
</template>

<script>
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();

import { batchUpdateRebateApi } from '@/api/media';
import { formDataAssign } from '@/tools/form';

export default {
  name: 'MediasManage',
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      /** 过滤项 */
      table_filter: require('./model/table-filter')(this),
      /** 表头数据 */
      table_key: require('./model/table-key')(this),
      /** 表格请求参数 */
      table_params: {
        type: 'jrtt',
        page: 1,
        limit: 10,
      },
      /** 表格多选数据 */
      multiple_selection: [],
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        title: '',
        form_config: {},
        confirm: () => {},
      },
    };
  },
  methods: {
    /** 搜索 */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /**
     * 表格多选事件
     * @param {Object[]} rows 表格多选数据
     */
    onSelectionChange(rows) {
      this.multiple_selection = rows;
    },
    /**
     * 获取媒体账号
     * @param {object} data 过滤参数
     * @returns {Promise<Object>}
     */
    getMediasList(data) {
      return new Promise((resolve, reject) => {
        mediasResource.getMediasListApi(data).then(resolve).catch(reject);
      });
    },
    /**
     * 同步媒体账号
     * @returns {Promise<Object>}
     */
    pullMedias() {
      return new Promise((resolve, reject) => {
        mediasResource.syncMedias()
          .then(res => {
            this.$message.success(res.message || '正在同步中');
            resolve();
          })
          .catch(error => {
            this.$message.error(`同步媒体账号失败`);
            reject(error);
          });
      });
    },
    /**
     * 编辑备注
     * @param {object} data 列表项数据
     */
    editNote(data) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '修改',
        form_config: require('./model/edit-note-form-config.js')(),
        confirm: (params) => {
          mediasResource.updateMediasApi(params)
            .then(() => {
              this.$message.success('修改成功！');
              this.dialog_config.is_show = false;
              this.$refs.table.refer();
            });
        },
      });

      formDataAssign(this.dialog_config.form_config, data);
      this.dialog_config.form_config.type.value = this.table_params.type;
    },
    /**
     * 编辑返点
     * @param {object} data 列表项数据
     */
    editRebate(data) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '设置返点',
        form_config: require('./model/edit-rebate-form-config.js')(),
        confirm: (params) => {
          const { channel_interface, advertiser_id, app_id } = this.dialog_config.form_config;
          mediasResource.updateAdvertiserRebateApi({
            channel_interface: channel_interface.value,
            advertiser_id: advertiser_id.value,
            app_id: app_id.value,
            ...params,
          }).then(() => {
            this.$message.success('设置成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.refer();
          });
        },
      });

      formDataAssign(this.dialog_config.form_config, data);
      this.dialog_config.form_config.channel_interface.value = this.table_params.type;
    },
    /**
     * 批量编辑返点
     */
    batchEditRebate() {
      if (!this.multiple_selection.length) {
        this.$message.warning('请选择广告账户！');
        return;
      }
      const ids = this.multiple_selection.map(({ id }) => id);
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '批量设置返点',
        form_config: require('./model/batch-edit-rebate-form-config.js')(),
        confirm: (params) => {
          batchUpdateRebateApi(params).then(({ message }) => {
            this.$message.success(message || '设置成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.refer();
          });
        },
      });

      this.dialog_config.form_config.ids.value = ids;
    },
    /**
     * 刷新授权缓存
     */
    refreshAuthCache() {
      mediasResource.refreshCacheApi({
        channel_interface: this.table_params.type,
      }).then(({ message }) => {
        this.$message.success(message || '刷新成功');
      });
    },

    /**
     * 刷新Token
     * @param {string} app_id 应用APPID
     * @param {string} advertiser_id 广告主ID
     */
    refreshToken(app_id, advertiser_id) {
      mediasResource.refreshTokenApi({
        channel_interface: this.table_params.type,
        app_id,
        advertiser_id,
      }).then(({ message }) => {
        this.$message.success(message || '刷新成功！');
      });
    },
    /**
     * 测试Token
     * @param {string} advertiser_id 广告主ID
     */
    testToken(advertiser_id) {
      mediasResource.testTokenApi({
        channel_interface: this.table_params.type,
        advertiser_id,
      }).then(({ message }) => {
        this.$message.success(message || '测试成功！');
      });
    },
    /**
     * 修改用户状态（账号状态）
     * @param {object} row 列表项数据
     */
    editAccountStatus(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '修改账号状态',
        form_config: require('./model/edit-account-status-form-config.js')(row.account_status),
        confirm: (params) => {
          mediasResource.updateAccountStatusApi({
            id: row.id,
            ...params,
          }).then(({ message }) => {
            this.$message.success(message || '修改成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.refer();
          });
        },
      });
    },
    /**
     * 批量修改账号状态
     */
    batchUpdateAccountStatus() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '批量修改账号状态',
        form_config: require('./model/batch-edit-account-status-form-config.js')(),
        confirm: (params) => {
          const advertiser_ids = params.advertiser_ids
            .split('\n')
            .map(id => id.trim())
            .filter(Boolean);
          mediasResource.batchUpdateAccountStatusApi({
            advertiser_ids,
            status: params.status,
          }).then(({ message }) => {
            this.$message.success(message || '修改成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.refer();
          });
        },
      });
    },
  },
};
</script>
